// extracted by mini-css-extract-plugin
export default {"root":"TriggersSection_root__R7JzC","table":"TriggersSection_table__8MIdy","noResults":"TriggersSection_noResults__v-W06"};